import React, { Component } from 'react'
import Moment from 'moment'
import MenuItem from 'material-ui/MenuItem'
import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import LeasesTable from './Table'
import LeaseForm from '../leaseForm'
import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'
import filtersActions from 'actions/filters'
import Search from 'components/Search'

export default class LeasePage extends Component {
	render() {
		let { props } = this
		let detailID = props.routeParams.id
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'lease'} />
					<Notifications />
					{<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'lease'} id="search-leases" style={{marginTop: "-8px"}}/><
					/div>}
				</div>
				<AddButton object={{
					type:'lease'
			      , date: Moment(new Date()).format('YYYY-MM-DD')
				  , dateFrom: Moment(new Date()).add("1", "day").format("YYYY-MM-DD")
				  , dateTill: Moment(new Date()).add("1", "year").format("YYYY-MM-DD")
			}} color="#FFF" detailID={detailID}/>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <LeasesTable {...props} detailID={detailID} />}
				detail={props => <LeaseForm {...props} id={detailID} /> }
				detailColumns={1}
				detailOpen={!!detailID}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/leases/index.js